import { profile } from '../data/content';
import { NameMark } from './NameMark';
import { delay } from './primitives';

export function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__inner">
        <div className="rule fade-in" style={delay(0)} />

        <NameMark />

        <p className="hero__label fade-in" style={delay(2200)}>
          {profile.label}
        </p>

        <div className="rule fade-in" style={delay(2300)} />

        <p className="hero__tagline fade-in" style={delay(2450)}>
          {profile.intro}
        </p>

        <div className="hero__actions fade-in" style={delay(2600)}>
          <a className="btn btn--ghost" href="#projects">
            See the work
          </a>
          <a className="btn btn--ghost" href="#contact">
            Get in touch
          </a>
        </div>
      </div>

      <a className="scroll-cue" href="#about" aria-label="Scroll to About" />
    </section>
  );
}
